import '../CSSFiles/App.css';
import { NavBar } from '../Components/NavBar';
import hero_image from "../Images/hero-image.png"
import { ServiceDescription } from '../Components/ServicesDescription';
import laptop_desk from "../Images/laptop_desk.png"
import { PopUp } from '../Components/PopUp';
import {useEffect, useRef, useState} from "react"
import { PopUpCode } from '../Components/PopUpCode';

function App(props) {

  const [phone_number, set_phone_number] = useState("")
  const [code, set_code] = useState("");
  const [error_message, set_error_message] = useState("")
  const [promotion_text, set_promotion_text] = useState("");

  useEffect(() => {
    if (props.user_origin == "facebook_synthetic_oil_deal") {
      set_promotion_text("synthetic_oil_change")
    }
    else if (props.user_origin == "facebook_general_services") {
      set_promotion_text("general_services")
    }

  }, [])

  const name_ref = useRef(null)
  const email_ref = useRef(null)
  const purpose_ref = useRef(null)

  const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
    ];

  const [selected_date, set_selected_date] = useState(null)
  
const submitHandler = (e) => {
      e.preventDefault();


      if (selected_date == null) {
        set_error_message("Please select a day for the visit")
        return false;
      }
      if (!name_ref || !email_ref) {
        return;
      }

      let year = selected_date.getFullYear();
      let month = selected_date.getMonth() > 9 ? selected_date.getMonth() : "0" + selected_date.getMonth();
      let date_day = selected_date.getDate() > 9 ? selected_date.getDate() : "0" + selected_date.getDate();
      const json_message = {
        first_name: name_ref.current.value,
        last_name: "",
        date: (year + "-" + month + "-" +  date_day),
        time: "00:00",
        phone_number: phone_number,
        email: email_ref.current.value,
        purpose: purpose_ref.current.value,
        user_origin: props.user_origin
      };


      fetch('https://nnduck12345.org/public-projects/nova_auto_repairs/make_appointments.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(json_message)
    })
    .then(async res => {
      const text = await res.text();
      try {
        const data = JSON.parse(text);
        set_code(data.code)
        try {
          if (data.code.length == 5) {
            name_ref.current.value = "";
            set_selected_date(null)
            set_phone_number("");
            email_ref.current.value = "";
            purpose_ref.current.value = "";
          }
          set_error_message("");
        }
        catch( e) {
          console.log(e)
        }
      } catch {
        console.error("Server returned invalid JSON. Raw response:", text);
      }
    })
    .catch(err => {
      console.error("Error sending request:", err);
    });


    document.querySelector("#code-popup").classList.remove("disp_none");
    };

  const CheckValidDate = (date, time) => {
    const made_date = new Date(`${date}T${time}`);


    if (dayNames[made_date.getDay()] == "Sunday") {
      return "We are not open on Sundays"
    }
    
    if (dayNames[made_date.getDay()] == "Saturday") {
      if (made_date.getHours() >= 17) {
        return "We are not open past 5pm on Saturdays"
      }
      else if (made_date.getHours() < 8) {
        return "We are not open before 8am on Saturdays"
      }
    }

    if (made_date.getHours() >= 18) {
        return "We are not open past 6pm on " + dayNames[made_date.getDay()];
    }
    else if (made_date.getHours() < 8) {
      return "We are not open before 8am on " + dayNames[made_date.getDay()];
    }
    else {
      return "We are open"
    }
  }

  const HandlePhoneNumberChange = (e) => {

    const current_value = phone_number.replace(/\D/g, '')
    const current_value_length = current_value.length

    const value = e.target.value.replace(/\D/g, '');
    const value_length = value.length;

    if (value.length > 10)
      return;

    let new_val = null;

    if (e.target.value.length < phone_number.length) {
      new_val = value
      set_phone_number(new_val)
    }
    else if (value_length > current_value_length && (value[value_length - 1] >= 0 && value[value_length - 1] <= 9)) {
      new_val = value
    }
    
    if (!new_val)
      return;


    set_phone_number(FormatNumber(new_val))

  }

  function FormatNumber(input) {
    let returned_string = "("
    for (let i = 0; i < input.length; i++) {
      switch(i) {
        case 3:
          returned_string += (")" + "-"  + input[i])
          break
        case 6:
          returned_string += ("-" + input[i])
          break;
        default:
          returned_string += input[i]
      }
    }


    return returned_string
  }

  const ScrollToScheduleInformation = () => {
        document.getElementById('schedule-visit').scrollIntoView({ behavior: 'smooth'});
  }

  const SelectDateOnCalender = (selected_date_index) => {
    const new_array = appointments_array.map((item, index) => ({
        ...item,
        isSelected: index === selected_date_index
      })
    );

    set_selected_date(new_array[selected_date_index].date);
    set_appointments_array(new_array);
};



  const [appointments_array, set_appointments_array] = useState([])
  const [currentDate, setCurrentDate] = useState();

  const SetMonthInformation = (set_date) => {

      if (!set_date) {
        return;
      }
      const year = set_date.getFullYear();
      const month = set_date.getMonth();

      const first_day_of_month = new Date(year, month, 1);
      const last_day_of_month = new Date(year, month + 1, 0);

      const days_array = [];

      // Days from previous month to fill week
      for (let i = first_day_of_month.getDay(); i > 0; i--) {
          days_array.push({
            date: new Date(year, month, 1 - i),
            isClickable: false,
            isSelected: false
          });
      }

      // Current month days
      for (let i = 1; i <= last_day_of_month.getDate(); i++) {
        let today_at_8 = new Date();
        today_at_8.setHours(8, 0, 0, 0)
        let today = new Date();

        
          days_array.push({
            date: new Date(year, month, i),
            isClickable: ( (new Date(year, month, i)).getDay() != 0 && today_at_8 < (new Date(year, month, i, today.getHours()))),
            isSelected: false
          });
          
      }

      // Fill in the rest of the week with next month's days
      for (let i = 1; i <= (6 - last_day_of_month.getDay()); i++) {
          days_array.push({
            date: new Date(year, month + 1, i),
            isClickable: false,
            isSelected: false
            });
      }

      set_appointments_array(days_array); // make sure this function is in scope
  };

  const ChangeMonth = (goForward) => {
    if (!currentDate)
      return


    if (goForward) {
      let month = currentDate.getMonth() + 1;
      let year = currentDate.getFullYear();

      if (month > 11) {
        year++;
        month = 0;
      } 
      setCurrentDate(new Date(year, month, 1));
    }
    else {
      let month = currentDate.getMonth() - 1;
      let year = currentDate.getFullYear();

      if (month < 0) {
        year--;
        month = 11;
      } 
      setCurrentDate(new Date(year, month, 1));

    }
  }


  useEffect(() => {
    if (props.user_origin == "facebook_synthetic_oil_deal") {
      ScrollToScheduleInformation();
      document.getElementById('purpose').parentElement.classList.add("disp_none")
      
      purpose_ref.current.value = "Oil Change"
    }
    setCurrentDate(new Date());

  }, [])

  useEffect(() => {
    SetMonthInformation(currentDate)
    set_selected_date(null)
  }, [currentDate])



  return (
    <div className="App">
        <PopUpCode code={code} user_origin={props.user_origin}/>
      <NavBar />
      <PopUp user_origin={props.user_origin}/>
      <img src={hero_image} className="hero-image"/>
      <h1 id='services'> Services </h1>
      <div className="services-section" >
        <div className="services-part">
          <ServiceDescription ServiceName="Transmission & Engine Replacement" ServiceText="Engine or transmission issues are serious, but we make the repair process as smooth as possible. Whether due to wear, overheating, or failure, we provide full replacement using quality parts and expert installation.We start with a thorough inspection, explain your options clearly, and finish with complete testing to ensure your vehicle runs reliably. For major repairs, you can count on us."/>
          <ServiceDescription ServiceName="Brakes Complete Work" ServiceText="Your brakes are one of the most important safety systems on your vehicle, and we make sure they're working exactly as they should. From pad and rotor replacement to full brake system diagnostics and repairs, we handle it all. Whether you're hearing squeaks, feeling vibrations, or just due for maintenance, our team will inspect, repair, and test your brakes so you can drive with confidence."/>
          <ServiceDescription ServiceName="Suspension System"  ServiceText="A worn suspension doesn't just make your ride uncomfortable—it can affect steering, braking, and even tire life. If you're feeling every bump or noticing unusual noises, it's time for a check. We inspect and repair shocks, struts, control arms, and other components to restore comfort, control, and safety to your drive." />
        
        </div>
        <div className="services-part">
          <ServiceDescription ServiceName="Tire Replacement" ServiceText="Tires play a critical role in handling, safety, and fuel efficiency. If your tread is worn or your tires are aging, we'll help you choose the right set for your vehicle and driving habits. We provide complete tire replacement services, including mounting, balancing, and pressure checks, so you're ready for any road condition with peace of mind." />
          <ServiceDescription ServiceName="Air Conditioning" ServiceText="A failing A/C system can make driving unbearable during the warmer months. Whether your system needs a recharge, has a refrigerant leak, or requires a full compressor replacement, we'll find the issue and fix it fast. We service all makes and models to ensure your air conditioning runs cold, clean, and consistently—even on the hottest days." />
          <ServiceDescription  ServiceName="Alignment"  ServiceText="If your car pulls to one side, your steering wheel feels off-center, or your tires show uneven wear, it's likely an alignment issue. Proper wheel alignment improves vehicle handling, increases fuel efficiency, and extends the life of your tires. Using precision alignment tools, we'll restore your vehicle's geometry to factory specs for a safer, smoother drive." />
        </div>
        <div className="services-part">
        </div>
       
      

        
      </div>

      
      <h1 className="contact-info-title"> Contact Information</h1>
      <div className="contact-info" id='contact-info'>
        <img src={laptop_desk} />
        <div className="info">
          <div className="info-pair">
            <h3> Phone</h3>
            <p> (571)-598-4191</p>
          </div>
          <div className="info-pair">
            <h3> Email Us</h3>
            <p> novaautor@gmail.com</p>
          </div>
          <div className="info-pair">
            <h3> Address </h3>
            <p> {"9106 Euclid Ave\nManassas, VA 20110"}</p>
          </div>
        </div>
      </div>

      <h1 className="schedule-visit" id="schedule-visit"> Let us know when you're coming </h1>
      <div className="appointment-form">
        
        {promotion_text == "synthetic_oil_change" && <h3> And get <span className="green-text"> Synthetic Oil Change </span> + Free checkup for only <span className="green-text">$35</span> </h3>}
        {promotion_text != "synthetic_oil_change" && <h3> And get <span className="green-text"> 20% OFF </span> for <span className="green-text">ALL</span> general services!</h3> } 

        <form onSubmit={submitHandler} className="form-appointment">
        <div className="inputs-section">
           <div className="info-part" style={{justifyContent: "center"}}>
            <div className="input-component">
              <label htmlFor='first_name'> Name: </label>
              <input required type="text" ref={name_ref}id="first_name" placeholder='John Doe'/>
            </div >
          </div>
          <div className="info-part" style={{justifyContent: "center"}}>
           
           <div className="calendar">
            <div className="over-view-info">
              <h3 className='nav-arrows' onClick={() => {ChangeMonth(false)}}> {"<"}</h3>
              <h3> {currentDate && months[currentDate.getMonth()]}  {currentDate && currentDate.getFullYear()}</h3>
              <h3 className='nav-arrows' onClick={() => {ChangeMonth(true)}}> {">"}</h3>
            </div>
            <div className="main-calendar">
              <div className="day-title">Sun</div>
              <div className="day-title">Mon</div>
              <div className="day-title">Tue</div>
              <div className="day-title">Wed</div>
              <div className="day-title">Thu</div>
              <div className="day-title">Fri</div>
              <div className="day-title">Sat</div>

              {appointments_array.map((item, index) => {
                return <p key={index}className={`${item.isSelected? "selected-day" : ""} day ${!item.isClickable? "day-unclickable" : "clickable-day"}`} onClick={() => {
                  if (item.isClickable)
                    SelectDateOnCalender(index)
                }}>{item.date.getDate()}</p>
              })}
            </div>  
          </div>

          </div>
          <div className="info-part">
            <div className="input-component">
              <label htmlFor='phone_number'>Phone Number: </label>
              <input required type="text" value={phone_number} id="phone_number" placeholder='(571)-598-4191'  pattern="\([0-9]{3}\)-[0-9]{3}-[0-9]{4}" onChange={HandlePhoneNumberChange}/>
            </div >
            <div className="input-component">
              <label htmlFor='mail'>Email: </label>
              <input required type="email" ref={email_ref}id="mail" placeholder='novaautor@gmail.com'/>
            </div >
            
          </div>
          <div className="info-part">
            <div className="input-component" style={{width: "100%"}}>
              <label htmlFor='purpose'>Purpose: </label>
              <textarea id="purpose" ref={purpose_ref} placeholder='I would like to get my car’s health checked....'></textarea>
            </div >
      
          </div>
        </div>
      
        <p className="submit-error"> {error_message}</p>
        <button type="submit" className="submit-appointment"> Schedule Visit </button>
        </form>

        
      </div>
    </div>
  );
}

export default App;
